const CROWN_WISHLIST_KEY = 'crown:wishlist:v1';

const readWishlist = () => {
  try {
    const value = window.localStorage.getItem(CROWN_WISHLIST_KEY);
    const parsed = value ? JSON.parse(value) : [];
    return Array.isArray(parsed) ? parsed.filter((item) => item && item.handle) : [];
  } catch (error) {
    return [];
  }
};

const writeWishlist = (items) => {
  window.localStorage.setItem(CROWN_WISHLIST_KEY, JSON.stringify(items));
  window.dispatchEvent(new CustomEvent('crown:wishlist:changed', { detail: { items } }));
};

const absoluteUrl = (value) => {
  if (!value) return '';
  if (value.startsWith('//')) return `${window.location.protocol}${value}`;
  return value;
};

const itemFromButton = (button) => ({
  id: button.dataset.productId || '',
  handle: button.dataset.productHandle || '',
  title: button.dataset.productTitle || '',
  url: button.dataset.productUrl || `/products/${button.dataset.productHandle || ''}`,
  image: absoluteUrl(button.dataset.productImage || ''),
  price: button.dataset.productPrice || '',
  comparePrice: button.dataset.productComparePrice || '',
  variantId: button.dataset.productVariantId || '',
  available: button.dataset.productAvailable !== 'false',
  addedAt: Date.now(),
});

const isSaved = (items, handle) => items.some((item) => item.handle === handle);

const syncButtons = () => {
  const items = readWishlist();
  document.querySelectorAll('[data-crown-wishlist-button]').forEach((button) => {
    const saved = isSaved(items, button.dataset.productHandle || '');
    const title = button.dataset.productTitle || 'product';
    const saveLabel = button.dataset.crownWishlistSaveLabel || `Save ${title} to wishlist`;
    const removeLabel = button.dataset.crownWishlistRemoveLabel || `Remove ${title} from wishlist`;
    button.classList.toggle('is-active', saved);
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    button.setAttribute(
      'aria-label',
      saved ? removeLabel : saveLabel
    );
  });
};

const syncCounts = () => {
  const count = readWishlist().length;
  document.querySelectorAll('[data-crown-wishlist-count]').forEach((target) => {
    target.textContent = String(count);
    target.hidden = count === 0;
  });
};

const renderWishlistPage = () => {
  const root = document.querySelector('[data-crown-wishlist-root]');
  if (!root) return;

  const grid = root.querySelector('[data-crown-wishlist-grid]');
  const empty = root.querySelector('[data-crown-wishlist-empty]');
  const countLabel = root.querySelector('[data-crown-wishlist-count-label]');
  if (!grid || !empty || !countLabel) return;

  const items = readWishlist();
  const countOtherTemplate = root.dataset.countOther || '__COUNT__ saved products';
  const viewProductText = root.dataset.viewProductText || 'View product';
  const removeTemplate = root.dataset.removeLabelTemplate || 'Remove __TITLE__ from wishlist';
  grid.innerHTML = items.map((item) => {
    const image = item.image
      ? `<img src="${item.image}" alt="${escapeHtml(item.title)}" loading="lazy">`
      : '<span class="crown-wishlist-card__placeholder" aria-hidden="true"></span>';
    const comparePrice = item.comparePrice
      ? `<span class="crown-wishlist-card__compare">${escapeHtml(item.comparePrice)}</span>`
      : '';

    return `
      <article class="crown-wishlist-card" data-crown-wishlist-card="${escapeHtml(item.handle)}">
        <a class="crown-wishlist-card__link" href="${escapeAttribute(item.url)}" aria-label="${escapeAttribute(item.title)}"></a>
        <div class="crown-wishlist-card__media">
          ${image}
          <button class="crown-wishlist-card__remove button-unstyled" type="button" data-crown-wishlist-remove="${escapeAttribute(item.handle)}" aria-label="${escapeAttribute(removeTemplate.replace('__TITLE__', item.title))}">
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M20.5 5.9c-1.5-1.7-4-1.8-5.7-.3L12 8.1 9.2 5.6C7.5 4.1 5 4.2 3.5 5.9 2 7.6 2.1 10.2 3.8 11.8L12 19.3l8.2-7.5c1.7-1.6 1.8-4.2.3-5.9Z" />
            </svg>
          </button>
        </div>
        <div class="crown-wishlist-card__body">
          <h2><a href="${escapeAttribute(item.url)}">${escapeHtml(item.title)}</a></h2>
          <p class="crown-wishlist-card__price">${comparePrice}<span>${escapeHtml(item.price)}</span></p>
          <a class="crown-wishlist-card__cta" href="${escapeAttribute(item.url)}">${escapeHtml(viewProductText)}</a>
        </div>
      </article>
    `;
  }).join('');

  empty.hidden = items.length > 0;
  grid.hidden = items.length === 0;
  countLabel.textContent = items.length === 0
    ? root.dataset.countZero || '0 saved products'
    : items.length === 1
      ? root.dataset.countOne || '1 saved product'
      : countOtherTemplate.replace('__COUNT__', items.length);
};

const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (character) => ({
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
}[character]));

const escapeAttribute = escapeHtml;

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-crown-wishlist-button]');
  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  const nextItem = itemFromButton(button);
  if (!nextItem.handle) return;

  const currentItems = readWishlist();
  const nextItems = isSaved(currentItems, nextItem.handle)
    ? currentItems.filter((item) => item.handle !== nextItem.handle)
    : [nextItem, ...currentItems.filter((item) => item.handle !== nextItem.handle)];

  writeWishlist(nextItems);
});

document.addEventListener('click', (event) => {
  const removeButton = event.target.closest('[data-crown-wishlist-remove]');
  if (!removeButton) return;

  const handle = removeButton.dataset.crownWishlistRemove;
  writeWishlist(readWishlist().filter((item) => item.handle !== handle));
});

const syncWishlist = () => {
  syncButtons();
  syncCounts();
  renderWishlistPage();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', syncWishlist, { once: true });
} else {
  syncWishlist();
}

window.addEventListener('crown:wishlist:changed', syncWishlist);
document.addEventListener('shopify:section:load', syncWishlist);
